import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const MultiLineIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "multi-line",
  "MultiLineIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1102)"><path d="M7.3335 2.66663H1.3335V3.99996H7.3335V2.66663Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M7.3335 7.33331H1.3335V8.66665H7.3335V7.33331Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M7.3335 12.0001H1.3335V13.3334H7.3335V12.0001Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M11.6667 4.72391L8.39057 8.00005L11.6667 11.2762L12.6095 10.3334L10.9429 8.66672L15.3334 8.66672L15.3334 7.33339L10.9429 7.33339L12.6095 5.66672L11.6667 4.72391Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1102"><rect width="16" height="16" fill={colorList[1]} transform="matrix(-1 0 0 1 16 0)"/></clipPath></defs></g></svg>
);

export default MultiLineIcon;
